import React from 'react';
import { calcTransportCosts } from '../dailytrips/calc_costs';


export default class CostsTable extends React.Component {
	constructor(props) {
		super(props);
		this.lp = window.datastore.lps.get(this.props.placeid)
		this.state = {
				costsPeriod: "month"
		}
		this.changeCostsPeriod = this.changeCostsPeriod.bind(this);
	}
	
	changeCostsPeriod (e) {
		this.setState({
			costsPeriod: e.target.value
		})
	}
	
	render() {
		
		function numberWithCommas(x) {
		   // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
			return x.toLocaleString('de-AT')
		}
		
		function calcCosts(id, comp) {
			// Monthly costs [Costs for cars, costs for Public, total costs for living, costs for credit/rent, running costs, kilometer with car, co2]
			var costs_month = calcTransportCosts(id)
			var costs_year = [];
			// Check state for desired period
			if (comp.state.costsPeriod === "month") {
				return costs_month
			} else if (comp.state.costsPeriod === "year") {
				for (var i = 0; i < costs_month.length; i++) {
					costs_year.push(Math.round(costs_month[i] * 12))
				}
				return costs_year;
			} 
		}
		
		var costs = null;
		var costs2 = null;
		
		if (this.props.placeid === "2") {
			var costs = calcCosts("1", this)
			var costs2 = calcCosts("2", this)
		}
		else {
			var costs = calcCosts(this.props.placeid, this)
		}
		
	    return (
<div>
    <div className="panel panel-default">
        <div className="panel-body">
            <form>
                <div className="form-group">
                    <label htmlFor="select-period">Zeitraum</label>
                    <select className="form-control period-select" id="select-period" value={this.state.costsPeriod} onChange={this.changeCostsPeriod}>
                        <option value="month">Monat</option>
                        <option value="year">Jahr</option>
                    </select>
                </div>
            </form>
            <table className="table">
                <thead>
                    <tr>
                        <th>Kostentyp</th>
                        <th className="text-right">{this.props.placeid === "2" ? window.datastore.lps.get("1").get("name") : "€"}</th><th className="text-right">{this.props.placeid === "2" ? window.datastore.lps.get("2").get("name") : ''}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>Wohnkosten</th>
                        <td className="bold text-right">{numberWithCommas(costs[2])}</td><td className="bold text-right">{this.props.placeid === "2" ? (numberWithCommas(costs2[2])) : ''}</td>
                    </tr>
                    <tr className="childrow">
                        <th>Kredit/Miete</th>
                        <td className="text-right">{numberWithCommas(costs[3])}</td><td className="text-right">{this.props.placeid === "2" ? (numberWithCommas(costs2[3])) : ''}</td>
                    </tr>
                    <tr className="childrow">
                        <th>Betriebskosten</th>
                        <td className="text-right">{numberWithCommas(costs[4])}</td><td className="text-right">{this.props.placeid === "2" ? (numberWithCommas(costs2[4])) : ''}</td>
                    </tr>
                    <tr>
                        <th>Mobilitätskosten</th>
                        <td className="bold text-right">{numberWithCommas(costs[0] + costs[1])}</td><td className="bold text-right">{this.props.placeid === "2" ? (numberWithCommas(costs2[0] + costs2[1])) : ''}</td>
                    </tr>
                    <tr className="childrow">
                        <th>Öff. Verkehr</th>
                        <td className="text-right">{numberWithCommas(costs[1])}</td><td className="text-right">{this.props.placeid === "2" ? (numberWithCommas(costs2[1])) : ''}</td>
                    </tr>
                    <tr className="childrow">
                        <th>KFZ</th>
                        <td className="text-right">{numberWithCommas(costs[0])}</td><td className="text-right">{this.props.placeid === "2" ? (numberWithCommas(costs2[0])) : ''}</td>
                    </tr>
                    <tr>
                        <th>Gesamtkosten</th>
                        <td className="bold text-right">{numberWithCommas(costs[0] + costs[1] + costs[2])}</td><td className="bold text-right">{this.props.placeid === "2" ? (numberWithCommas(costs2[0] + costs2[1] + costs2[2])) : ''}</td>
                    </tr>
                    <tr>
                        <th></th>
                        <td className="bold text-right"></td><td></td>
                    </tr>
                    <tr>
                        <th>Gesamte PKW-Strecke</th>
                        <td className="bold text-right">{numberWithCommas(costs[5])} km</td><td className="bold text-right">{this.props.placeid === "2" ? (numberWithCommas(costs2[5]))+' km' : ''}</td>
                    </tr>
                    <tr>
                    <th>Zeitaufwand für Wege</th>
                    <td className="bold text-right">{numberWithCommas(costs[6])} Std.</td><td className="bold text-right">{this.props.placeid === "2" ? (numberWithCommas(costs2[6]))+' Std.' : ''}</td>
                    
                </tr>
     		<tr>
                    <th>Verursachte CO2 Emissionen</th>
                    <td className="bold text-right">{numberWithCommas(Math.round(costs[7]/1000) + Math.round(costs[8]/1000))} kg</td><td className="bold text-right">{this.props.placeid === "2" ? (numberWithCommas(Math.round(costs2[7]/1000)+Math.round(costs[8]/1000)))+' kg' : ''}</td>
                    
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
	    )
	}
}



// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/results/coststable.js